<template>
  <img :src="finalSrc" :srcset="srcset" class="static-image">
</template>

<script setup>
import { computed } from 'vue';
import { convertStaticImage } from '@/utils/static'

/**
 * 静态图片组件, 自动设置2倍图和降级png
 */
const props = defineProps({
  src: {
    type: String,
    required: true
  }
})
const finalSrc = computed(() => {
  return convertStaticImage(props.src, 2)
})
const srcset = computed(() => {
  const x3 = convertStaticImage(props.src, 3)
  return x3 ? `${x3} 3x` : ''
})
</script>

<style lang="scss" scoped>
.static-image {
  user-select: none;
}
</style>
